import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { AlertTriangle, BookOpen, CheckCircle2, Info, X } from 'lucide-react';
import { IconButton } from './ui';

export default function HelpDrawer({ open, onOpenChange, route }) {
  const data = route?.help || {};
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="cc-drawer-overlay" />
        <Dialog.Content className="cc-help-drawer">
          <header>
            <div className="cc-help-drawer__mark"><BookOpen size={19} /></div>
            <div><span>Centrum pomocy</span><Dialog.Title>{route?.label || 'Moduł'}</Dialog.Title></div>
            <Dialog.Close asChild><IconButton label="Zamknij pomoc" icon={X} /></Dialog.Close>
          </header>
          <Dialog.Description>{data.summary || route?.description}</Dialog.Description>
          {!!data.steps?.length && <section><h3><CheckCircle2 size={16} /> Podstawowy workflow</h3><ol>{data.steps.map((step, index) => <li key={step}><span>{String(index + 1).padStart(2, '0')}</span><p>{step}</p></li>)}</ol></section>}
          {!!data.terms?.length && <section><h3><Info size={16} /> Pola i statusy</h3><ul>{data.terms.map((term) => <li key={term}>{term}</li>)}</ul></section>}
          {!!data.warnings?.length && <section className="cc-help-warning"><h3><AlertTriangle size={16} /> Uważaj</h3><ul>{data.warnings.map((warning) => <li key={warning}>{warning}</li>)}</ul></section>}
          <div className="cc-help-tip"><kbd>?</kbd><span>Pomoc możesz otworzyć także z nagłówka każdego modułu.</span></div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
